import Cookies from 'js-cookie'
import Avatar from '@/models/Avatar'
import Api from '@/api'
import router from '@/routes'

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    token: {
      accessToken: null,
      expiresIn: null,
      tokenType: 'Bearer',
      uuid: null
    },
    verificationToken: {
      token: null,
      expiresAt: null
    },
    timestamp: new Date().getTime(),
    isLoading: false
  },

  getters: {},

  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload
    },
    setUser(state, user) {
      state.user = user
    },

    clearUser(state) {
      state.user = null
    },

    setToken(state, token) {
      if (token) {
        Cookies.set('AUTH_TOKEN', token)
        state.token = token
        state.isAuthenticated = true
      }
    },

    clearToken(state) {
      Cookies.remove('AUTH_TOKEN')
      state.token = {
        accessToken: null,
        expiresIn: null,
        tokenType: 'Bearer',
        uuid: null
      }
      state.isAuthenticated = false
    },

    changeTimestamp(state) {
      state.timestamp = new Date().getTime()
    },

    setUserAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.user.avatar = avatar
      } else {
        state.user.avatar = new Avatar(avatar)
      }
    },

    setVerificationToken(state, token) {
      if (token) {
        state.verificationToken = token
      }
    },

    clearVerificationToken(state) {
      state.verificationToken = {
        token: null,
        expiresAt: null
      }
    }
  },

  actions: {
    init({ commit }) {
      const token = Cookies.getJSON('AUTH_TOKEN')
      commit('setToken', token)
    },

    async getAuthenticatedUser({ commit, state }) {
      await Api.get('/auth/me')
        .then(res => {
          commit('setUser', res.data.data)
        })
        .catch(err => {
          if (err.response.status === 401) {
            commit('clearToken')
            commit('clearUser')
          }
        })
    },

    logout({ commit }) {
      Api.post('/auth/logout').then(() => {
        commit('clearToken')
        commit('clearUser')
        commit('clearVerificationToken')
        // clear other states as deemed necessary

        // router.replace({ name: 'auth.login-page' })

        // reload to clear all data
        // can be replaced with manually clearing of data
        router.push({
          name: 'auth.login-page'
        })
      })
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post('auth/profile/avatar', formData)
      commit('setUserAvatar', data.data)
    },

    async updateUser({ commit }, formData) {
      const { data } = await Api.put('auth/profile', formData)
      commit('setUser', data.data)
    },

    async deleteAccount({ commit, dispatch }) {
      await Api.delete('auth/account')
      commit('clearToken')
      commit('clearUser')
      commit('clearVerificationToken')
      // clear other states as deemed necessary

      router.replace({ name: 'auth.login-page' })
    },

    async getVerificationToken({ commit }, formData) {
      const { data } = await Api.post(
        'auth/account/verification-token',
        formData
      )
      commit('setVerificationToken', data.data)
    },

    async requestChangeEmail({ commit }, formData) {
      await Api.post('auth/change/email', formData)
    },

    async verifyChangeEmail({ state, commit }, formData) {
      await Api.post('auth/change/email/verify', formData)
      commit('clearVerificationToken')
      state.user.email = formData.email
    },

    async requestChangePhone({ commit }, formData) {
      await Api.post('auth/change/phone-number', formData)
    },

    async verifyChangePhone({ state, commit }, formData) {
      await Api.post('auth/change/phone-number/verify', formData)
      commit('clearVerificationToken')
      state.user.business_contact_number = formData.business_contact_number
    },

    async changePassword({ commit }, formData) {
      await Api.post('auth/change/password', formData)
      commit('clearVerificationToken')
    },
    async checkInvitationToken({ commit }, payload) {
      commit('setLoading', true)
      await Api.post('check/invitation-token', payload)
      commit('setLoading', false)
    },
    async acceptInvitation({ commit }, payload) {
      commit('setLoading', true)
      const { data } = await Api.post('/accept/invitation', payload)
      commit('setLoading', false)
      return data
    },
    async requestVerificationEmail({ commit }) {
      await Api.post('auth/verification/resend')
    }
  }
}
